var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroSvgBgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 1014,
    viewBox: "0 0 374 1014",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M373.6 992.3c-2.8-146.5-40.9-297-152-408.8A505.8 505.8 0 00-37.6 443.2a505.4 505.4 0 00259.2-140.3c106-106.7 148.5-250.2 152.2-389l.2-19.5V-128h-64c-8.4 0-16.9.2-25.3.6-123.7 6-248.3 56-341.5 149.8-98.6 99.4-148.4 290.2-149.2 420.5v.5c.8 130.5 50.5 321 149.3 420.5 95.2 96 223.5 146 349.8 150.1h80.5v-21.7zM-21.5 48.8c0 .4 0 0 0 0z",
    fill: "#5700FF"
  })));
}
export default SvgHeroSvgBgLeft;